import { Grid } from '@qbe/ads-core';
import * as React from 'react';

type CoverSelectorGridProps = {
  children: Array<React.ReactElement<typeof CoverSelectorGridItem>>;
};

export const CoverSelectorGrid: React.FC<CoverSelectorGridProps> = ({ children }) => (
  <Grid container direction="row">
    {children}
  </Grid>
);

type CoverSelectorGridItemProps = {
  children: React.ReactNode;
};

export const CoverSelectorGridItem: React.FC<CoverSelectorGridItemProps> = ({ children }) => (
  <Grid item xs={12} md={6} padding={1}>
    {children}
  </Grid>
);
